export default "__VITE_ASSET__CeiWaDoc__"